import React from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';

const SupportTicketOverview = props => {
  const supportTicketTypeList = [
    {
      color: 'danger',
      description: (
        <I18nText id="affiliate_three_sixty.affiliate.support_ticket.open" />
      ),
      count: props.affiliate.currentOpenSupportTicketsSize,
    },
    {
      color: 'tertiary-accent',
      description: (
        <I18nText id="affiliate_three_sixty.affiliate.support_ticket.ready" />
      ),
      count: props.affiliate.currentReadySupportTicketsSize,
    },
    {
      color: 'warning',
      description: (
        <I18nText id="affiliate_three_sixty.affiliate.support_ticket.submitted" />
      ),
      count: props.affiliate.currentSubmittedSupportTicketsSize,
    },
    {
      color: 'success',
      description: (
        <I18nText id="affiliate_three_sixty.affiliate.support_ticket.resolved" />
      ),
      count: props.affiliate.currentResolvedSupportTicketsSize,
    },
  ];

  return (
    <>
      <div className="support-ticket-overview__title">
        <I18nText id="affiliate_three_sixty.affiliate.support_ticket.header" />
      </div>
      <ul className="support-ticket-overview__list">
        {supportTicketTypeList.map(item => (
          <li
            key={item.color}
            className={`support-ticket-overview__list-item support-ticket-overview--${item.color}`}
          >
            <div className="support-ticket-overview__list-status">
              <span className="support-ticket-overview__list-item-color-tag" />
              <span>{item.description}</span>
            </div>
            <div
              className={ClassNames('support-ticket-overview__list-count', {
                'support-ticket-overview__list-count-color': item.count > 0,
              })}
            >
              {item.count}
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

SupportTicketOverview.propTypes = {
  affiliate: PropTypes.shape({
    bookingsTotal: PropTypes.number,
    travelersTotal: PropTypes.number,
    currentWorkspacesSize: PropTypes.number,
    currentOpenSupportTicketsSize: PropTypes.number,
    currentReadySupportTicketsSize: PropTypes.number,
    currentSubmittedSupportTicketsSize: PropTypes.number,
    currentResolvedSupportTicketsSize: PropTypes.number,
    chargeableChannelCount: PropTypes.number,
    ndcChannelCount: PropTypes.number,
    clientName: PropTypes.string,
    briefing: PropTypes.string,
    briefingUpdatedAt: PropTypes.string,
  }).isRequired,
};

export default SupportTicketOverview;
